import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b436f68e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Modal_Content" }
const _hoisted_2 = { class: "Modal_Header" }
const _hoisted_3 = {
  key: 0,
  class: "Modal_Header_Title"
}
const _hoisted_4 = { class: "Modal_Main" }
const _hoisted_5 = {
  key: 1,
  class: "Modal_Table"
}
const _hoisted_6 = {
  key: 2,
  class: "Modal_Table"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "選択"),
    /*#__PURE__*/_createElementVNode("th", null, "受注ID"),
    /*#__PURE__*/_createElementVNode("th", null, "受付日付"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("取次CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("取次名"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("番線")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書店CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("書店名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN13桁"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("書誌名")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "受注数"),
    /*#__PURE__*/_createElementVNode("th", null, "担当者名"),
    /*#__PURE__*/_createElementVNode("th", null, "短冊メモ"),
    /*#__PURE__*/_createElementVNode("th", null, "社内備考")
  ])
], -1))
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "Text_Left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "Modal_Table_SyosiInfo Text_Left" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
// @ts-ignore
import InputCheckBox from "../atoms/Input/InputCheckBox";
import axios, { AxiosResponse } from "axios";

interface ResOrderHoldList {
  juchuId: number;
  juchuDetailId: number;
  meisaiId: number;
  chumonMode: number;
  toritugiCd: string;
  toritugiMei: string;
  bansen: string;
  toritugiSyotenCd: string;
  syotenMei: string;
  syosiCd: string;
  janCd: string;
  title: string;
  quantity: number;
  registerDate: string;
  kousinDate: string;
  salesName: string;
  tanzaku: string;
  companyRemarks: string;
  juchuStatus: number;
  userId: number;
  username: string;
  numberOfDetails: number;
}
interface OrderHoldList extends ResOrderHoldList {
  isHold: boolean;
}

// 保留データ操作-----------------------------------------------------
//保留データの取得

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalOrderHold',
  props: {
  selectedOrder: { type: Object },
},
  emits: ["close", "orderHoldCancel", "getOrderHoldData"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const props = __props;
const notyf = new Notyf();

//Emitの定義
const emit = __emit;

// 型定義------------------------------------------------------------
const orderHold_list = ref([] as OrderHoldList[]);
const getOrderHoldData = async () => {
  try {
    const res: AxiosResponse<ResOrderHoldList[]> = await axios.get(
      `${store.getters["getBaseUrl"]}/chumonHold/juchuList?janCd=${props.selectedOrder?.janCd}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    orderHold_list.value.splice(0);
    res.data.forEach((order) => {
      orderHold_list.value.push({
        ...order,
        isHold: true,
      });
    });
  } catch (error) {
    alert("受注保留データの取得に失敗しました");
    console.log(error);
  }
};
getOrderHoldData();

const closeModal = () => {
  emit("close");
};

//保留データの解除
const holdCancel = async () => {
  const selectedJuchuDetail_list = [...orderHold_list.value].filter(
    (order) => order.isHold === true
  );

  const selectedJuchuDetail_idList = [
    {
      juchuId: -1,
      juchuDetailId: -1,
    },
  ];
  selectedJuchuDetail_idList.splice(0);
  selectedJuchuDetail_list.forEach((order) => {
    selectedJuchuDetail_idList.push({
      juchuId: order.juchuId,
      juchuDetailId: order.juchuDetailId,
    });
  });
  // 受注データ未選択の場合は、API通信前に処理を中断する
  if (!selectedJuchuDetail_idList.length) {
    notyf.error("保留対象の受注データを選択してください");
    return;
  }
  const patchData = selectedJuchuDetail_idList;
  try {
    await axios.patch(`${store.getters["getBaseUrl"]}/chumonHold`, patchData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    notyf.success("受注保留データを解除しました");
    closeModal();
    //保留解除後の受注保留データを再取得
    emit("getOrderHoldData");
  } catch (error) {
    alert("受注保留データの解除に失敗しました");
    console.log(error);
  }
};

//全選択・全解除
const toggleSelectBox = (isSelected: boolean) => {
  orderHold_list.value.forEach((order) => {
    order.isHold = isSelected;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "Modal",
      onClick: closeModal
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.selectedOrder)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "保留受注一覧"))
          : _createCommentVNode("", true),
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "Modal_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (orderHold_list.value.length)
          ? (_openBlock(), _createBlock(_unref(InputCheckBox), {
              key: 0,
              id: "InputCheckBox",
              onChange: toggleSelectBox,
              props_selectFlg: true
            }))
          : _createCommentVNode("", true),
        (!orderHold_list.value.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_5, " 受注データがありません。 "))
          : _createCommentVNode("", true),
        (orderHold_list.value.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderHold_list.value, (order, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((order.isHold) = $event)
                      }, null, 8, _hoisted_8), [
                        [_vModelCheckbox, order.isHold]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(order.juchuDetailId), 1),
                    _createElementVNode("td", null, _toDisplayString(order.registerDate), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(order.toritugiCd), 1),
                      _hoisted_9,
                      _createTextVNode(_toDisplayString(order.toritugiMei), 1),
                      _hoisted_10,
                      _createTextVNode(_toDisplayString(order.bansen), 1)
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createTextVNode(_toDisplayString(order.toritugiSyotenCd), 1),
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(order.syotenMei), 1)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createTextVNode(_toDisplayString(order.syosiCd), 1),
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(order.janCd), 1),
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(order.title), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(order.quantity), 1),
                    _createElementVNode("td", null, _toDisplayString(order.username), 1),
                    _createElementVNode("td", null, _toDisplayString(order.tanzaku), 1),
                    _createElementVNode("td", null, _toDisplayString(order.companyRemarks), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "Modal_Footer" }, [
        _createElementVNode("button", {
          class: "Modal_Button BtnGreen",
          onClick: holdCancel
        }, " 保留解除 "),
        _createElementVNode("button", {
          class: "Modal_Button BtnGreenRev",
          onClick: closeModal
        }, " 一覧にもどる ")
      ])
    ])
  ]))
}
}

})